import React from 'react';

interface BatteryIndicatorProps {
  cx: number;
  cy: number;
  tireBottomY: number;
  tireWidth: number;
  show?: boolean;
  // When true, the low-battery state covers the whole tire box with a yellow
  // background and a large centered bolt (used in the Fleet Insight view).
  fullCover?: boolean;
}

const BatteryIndicator: React.FC<BatteryIndicatorProps> = ({
  cx,
  cy,
  tireBottomY,
  tireWidth,
  show,
  fullCover,
}) => {
  if (!show) return null;

  if (fullCover) {
    const boxHeight = tireBottomY - cy;
    const centerY = cy + boxHeight / 2;
    // Bolt path spans ~4 units wide and ~6 units tall; scale it up so it fills
    // most of the box while staying inside both dimensions.
    const boltScale = Math.min(tireWidth / 4, boxHeight / 6) * 0.85;

    return (
      <g>
        <rect
          x={cx - tireWidth / 2}
          y={cy}
          width={tireWidth}
          height={boxHeight}
          rx={3}
          fill="#fde047"
        />
        <path
          d="M6 2 L4 5 L5.5 5 L4.5 8 L7.5 5 L6.5 5 L8 2 Z"
          fill="#6e1515"
          transform={`translate(${cx}, ${centerY}) scale(${boltScale}) translate(-6, -5)`}
        >
          <animate
            attributeName="opacity"
            values="1;0.3;1"
            dur="1s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    );
  }

  const boltTopOffset = 0;

  return (
    <g>
      <path
        d="M6 2 L4 5 L5.5 5 L4.5 8 L7.5 5 L6.5 5 L8 2 Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
        transform={`translate(${cx - 6}, ${cy + boltTopOffset})`}
      />

      <rect
        x={cx - tireWidth / 2}
        y={tireBottomY - 4}
        width={tireWidth}
        height="4"
        rx="2"
        ry="2"
        fill="#6e1515"
        style={{
          borderBottomLeftRadius: '2px',
          borderBottomRightRadius: '2px',
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px',
        }}
      >
        <animate
          attributeName="opacity"
          values="1;0.3;1"
          dur="1s"
          repeatCount="indefinite"
        />
      </rect>
    </g>
  );
};

export default BatteryIndicator;
